import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent)

const isinvalidBrowser = browser.satisfies({
  // or in general
  chrome: '<=75',
  firefox: '<=72',
  safari: '<=10',
  opera: '<=70',
  'internet explorer': '<=11',
  'microsoft edge': '<=80',
  mobile: {
    safari: '<=10.0',
    'android browser': '<3.10'
  }
})

if (isinvalidBrowser) {
  const App = () => import('./fallback')
  console.log(browser)
  App()
} else {
  const App = () => import('./application')
  App()
}
